/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const GET_ALL_ORGANIZATIONS = "GET_ALL_ORGANIZATIONS";
export const SET_FILTERED_ORGANIZATIONS = "SET_FILTERED_ORGANIZATIONS";
export const GET_APPLICATIONS_FOR_ORGANIZATION = "GET_APPLICATIONS_FOR_ORGANIZATION";
export const SET_SELECTED_ORGANIZATION = "SET_SELECTED_ORGANIZATION";
export const SET_NO_ORGANIZATION = "SET_NO_ORGANIZATION";
export const GET_ORGANIZATIONS_LIST = "GET_ORGANIZATIONS_LIST";
export const SET_PAGINATION_ORG = "SET_PAGINATION_ORG";